var _radialGradient, _path, _radialGradient2, _path2, _linearGradient, _path3, _linearGradient2, _path4, _radialGradient3, _path5, _radialGradient4, _path6, _path7, _linearGradient3, _path8, _path9, _radialGradient5, _path10, _path11, _path12, _g, _linearGradient4, _path13, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGimp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-a",
    cx: 359.596,
    cy: -303.644,
    r: 45.158,
    gradientTransform: "matrix(1 0 0 -.435 -297.375 -72.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-a)",
    d: "M107.4 59.9c0 10.8-20.2 19.6-45.2 19.6S17 70.7 17 59.9s20.2-19.6 45.2-19.6 45.2 8.8 45.2 19.6z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-b",
    cx: 202.968,
    cy: -16.74,
    r: 47.581,
    gradientTransform: "matrix(1.773 0 0 -1.297 -313.84 14.359)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#857C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F19"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-b)",
    stroke: "#2E3436",
    strokeMiterlimit: 10,
    d: "M30.7 11.7S37.8 26.4 54.5 26c34.9-.9 41-19.1 41.9-21.7.9-2.6 2.2-2.2 2.5.2C110.3 107.7 20 63.4 16.8 45.9c17.9-5.2 13.6-15.3 13.6-15.3l.3-18.9z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-c",
    gradientUnits: "userSpaceOnUse",
    x1: 377.399,
    y1: -70.445,
    x2: 349.841,
    y2: -75.913,
    gradientTransform: "matrix(1 0 0 -1 -301.337 -16.654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-c)",
    d: "M43.9 55.3c16.7 3.3 25.2.2 30.1-3.6-1.3-1.7-3.6-3.6-3.6-3.6s5.8 1.6 7.9 4.3c2 2.6.8 4.3.2 7.6-1.2-3-3.4-4.1-3.7-5.3-4.4 6.3-15.5 6-30.9.6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-d",
    gradientUnits: "userSpaceOnUse",
    x1: 349.459,
    y1: -38.103,
    x2: 407.97,
    y2: -104.522,
    gradientTransform: "matrix(1 0 0 -1 -297.5 -17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    stroke: "url(#gimp-original-wordmark-d)",
    strokeMiterlimit: 10,
    d: "M96.5 10.2c-1.4 2.3-3.5 5-6.6 7.7-6.5 5.4-17.4 10.3-35.3 10.7-10.5.3-17.2-4.8-21.3-9.3L33 30.4c.3 1 1 3.4-.2 6.7-1.3 3.5-5.3 7.2-12.3 9.9.6 1.3 1.2 2.6 3.1 4.4 2.5 2.5 6.1 5.2 10.3 7.6 8.4 4.8 19.3 8.6 29.5 8.8 10.2.2 19.4-3.1 25.8-12.4 5.7-8.6 9-23.1 7.3-45.2z",
    fill: "none"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-e",
    cx: 260.968,
    cy: 17.46,
    r: 8.698,
    gradientTransform: "matrix(1.685 0 0 -1.685 -400.899 56.163)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-e)",
    stroke: "#888A85",
    strokeWidth: 0.783,
    strokeMiterlimit: 10,
    d: "M48.8 33.8c0 5.6-4.5 10.1-10.1 10.1s-10.1-4.5-10.1-10.1 4.5-10.1 10.1-10.1 10.1 4.6 10.1 10.1z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-f",
    cx: 209.674,
    cy: -170.214,
    r: 11.954,
    gradientTransform: "matrix(.797 -.46 -.537 -.931 -242.623 -23.267)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5B676B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141718"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-f)",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M28.8 37.6c4.9 6.8 4.9 15 .1 18.5-4.8 3.5-12.6.8-17.5-6s-4.9-15-.1-18.5c4.8-3.4 12.6-.7 17.5 6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3436",
    stroke: "#000",
    strokeWidth: 1.174,
    strokeMiterlimit: 10,
    d: "M46 35.3c0 2.7-2.2 4.8-4.8 4.8-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8c2.6 0 4.8 2.1 4.8 4.8z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-g",
    gradientUnits: "userSpaceOnUse",
    x1: 157.619,
    y1: -207.564,
    x2: 156.868,
    y2: -226.784,
    gradientTransform: "scale(1 -1) rotate(37 -170.853 -336.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.281,
    stroke: "url(#gimp-original-wordmark-g)",
    strokeMiterlimit: 10,
    d: "M12.1 33.9C10.6 35 9.7 37 9.8 39.8c.1 2.7 1.1 6 3.4 9 2.2 2.9 5.1 4.9 7.7 5.7 2.6.8 4.7.6 6.3-.6 1.6-1.2 2.4-3.3 2.4-6s-1.1-6-3.3-8.9-5-4.9-7.6-5.7c-2.7-.8-5-.6-6.6.6z",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.4 38.4c0 2.9-2 5.2-4.4 5.2s-4.4-2.3-4.4-5.2c0-2.9 2-5.2 4.4-5.2 2.5 0 4.4 2.3 4.4 5.2zM42.6 33.1c0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-h",
    cx: 238.858,
    cy: 30.974,
    r: 8.698,
    gradientTransform: "matrix(1.978 0 0 -1.978 -412.858 87.869)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B9B0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-h)",
    stroke: "#888A85",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    d: "M71.4 34.9c0 6.5-5.3 11.8-11.8 11.8s-11.8-5.3-11.8-11.8S53 23.1 59.5 23.1s11.9 5.3 11.9 11.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3436",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M68 36.7c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7s2.5-5.7 5.7-5.7c3.1 0 5.7 2.5 5.7 5.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.1 34c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-2.2 1.8-3.9 3.9-3.9s3.9 1.8 3.9 3.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.115 -.39 .39 -.115 24.715 29.689)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-i",
    gradientUnits: "userSpaceOnUse",
    x1: 1915.16,
    y1: -1061.496,
    x2: 1892.237,
    y2: -1081.433,
    gradientTransform: "matrix(-.115 .39 .39 .115 524.484 -501.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6E3D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#EA8113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#5C3307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07C12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-i)",
    stroke: "#673907",
    strokeWidth: 2.461,
    strokeLinecap: "round",
    d: "M-144.8 139l9.2 8.6c20.7-15.8 42.3-49.7 42.3-49.7 4.9-5.5-.3-9.3-5.4-5.9 0-.1-32.1 24.9-46.1 47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-j",
    gradientUnits: "userSpaceOnUse",
    x1: 2014.528,
    y1: -1149.438,
    x2: 2023.719,
    y2: -1140.932,
    gradientTransform: "matrix(-.115 .39 .39 .115 527.382 -504.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-j)",
    stroke: "#888A85",
    strokeWidth: 2.461,
    strokeLinecap: "round",
    d: "M-162.4 161.9l5.6 4.8 21-18.2.7-1.7h2.7c-1.1-3.9-7.3-10.8-11.9-10.8l.2 2.7-1.7.9-16.6 22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.461,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M-145.9 150.9l-10.8 13",
    fill: "none"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gimp-original-wordmark-k",
    cx: 1284.155,
    cy: -757.829,
    r: 18.754,
    gradientTransform: "matrix(-.181 .598 .613 .176 532.577 -472.016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-k)",
    d: "M-199.2 186.5c25.8 0 45.5 3.1 49.2-15.7 3-15.2-17.8-22.4-28.2-8.9-10 13-21 24.6-21 24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    fill: "#fff",
    d: "M-152.3 171.3c0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4 0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.4 2.9 6.4 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-135.7 147.1c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-l",
    gradientUnits: "userSpaceOnUse",
    x1: 2769.363,
    y1: 1.109,
    x2: 2755.794,
    y2: 12.318,
    gradientTransform: "matrix(-.241 .249 .249 .241 502.979 -510.793)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.428,
    fill: "url(#gimp-original-wordmark-l)",
    d: "M-182.4 181.9s9.2.2 15.1-3.5c2.1-1.3 3.8 1.6 1.2 2.7-5.4 2.3-16.3.8-16.3.8z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gimp-original-wordmark-m",
    gradientUnits: "userSpaceOnUse",
    x1: 367.057,
    y1: -72.712,
    x2: 362.519,
    y2: -73.805,
    gradientTransform: "matrix(1 0 0 -1 -297.5 -17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gimp-original-wordmark-m)",
    d: "M61.9 59.4c3.7.4 7.1-.7 8.4-1.2.2-1.4 1.3-4 5.1-4.2l-1.3-2.3S69.2 55 64 56l-2.1 3.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3 85.1l-4.8 27.8 9-.2-.7 2.5-9 .4-.9 6.2 15.7-.5L47.8 85l-15.5.1zm5.3 21l-3.1.1L37 91.9l3-.1-2.4 14.3zm11.8-14.9l6.2-.1-4.7 26.9H45zm4.4 26.2L59.6 85l24.4.3-5.6 32.1-6.2.1 4.5-25.3-2.8.1-4.6 25.7H63l4.5-25.9-2.8-.2-4.4 25.6zm33.4-31.9L80.7 122h6.2l.7-4.1 9.2-.2 5.9-32-15.5-.2zm4.5 26l-3 .1 3.6-19.7 2.8-.1-3.4 19.7zM51 82h6l-.7 6H50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGimp);
export default __webpack_public_path__ + "static/media/gimp.a4780b80d96f3b3c2e6e74d1fb051712.svg";
export { ForwardRef as ReactComponent };